export default{
    namespaced: true,
    /*
        1: Ingreso
        2: Urgencias
        3: Evolución
        4: Referencia/Traslado
        5: Interconsulta
        6: Pre operatoria
        7: Pre anestésica
        8: Post operatoria
        9: Post anestésica
        10: Transfusión
        11: Egreso
        12: Enfermeria
        13: Quimioterapia
        14: Int. de Estudios
    */
    state:{
        ecabezadoIndicas:
            '<b>DIETA</b><br><br><br>'+
            '<b>SOLUCIONES</b><br><br><br>'+
            '<b>MEDICAMENTOS</b><br><br><br>'+
            '<b>CUIDADOS GENERALES</b><br><br><br>'+
            '<b>HEMOCOMPONENTES</b><br><br><br>'+
            '<b>OTROS</b><br><br><br>',


        encabezadoNotas:{
            1:  '<b>MOTIVO DEL INGRESO</b><br><br><br>'+
                '<b>ANTECEDENTES HEREDO FAMILIARES</b><br><br><br>'+
                '<b>ANTECEDENTES PERSONALES NO PATOLÓGICOS</b><br><br><br>'+
                '<b>ANTECEDENTES PERSONALES PATOLÓGICOS</b><br><br><br>'+
                '<b>PADECIMIENTO ACTUAL</b><br><br><br>'+
                '<b>EXPLORACIÓN FÍSICA</b><br><br><br>'+
                '<b>PLAN DE MANEJO</b><br><br><br>'+
                '<b>INTERPRETACIÓN DE ESTUDIOS</b><br><br><br>'+
                '<b>PRONÓSTICO PARA LA VIDA</b><br><br><br>',

            3:  '<b>PROBLEMAS</b><br><br><br>'+
                '<b>SUBJETIVO</b><br><br><br>'+
                '<b>OBJETIVO</b><br><br><br>'+
                '<b>ANÁLISIS</b><br><br><br>'+
                '<b>PLAN DE MANEJO</b><br><br><br>'+
                '<b>INTERPRETACIÓN DE ESTUDIOS</b><br><br><br>'+
                '<b>PRONÓSTICO PARA LA VIDA</b><br><br><br>',

            11:  '<b>FECHA DE INGRESO</b><br><br><br>'+
                '<b>FECHA DE EGRESO</b><br><br><br>'+
                '<b>MOTIVO DE EGRESO</b><br><br><br>'+
                '<b>RESUMEN DE EVOLUCIÓN Y ESTADO ACTUAL</b><br><br><br>'+
                '<b>DIAGNÓSTICOS FINALES</b><br><br><br>'+
                '<b>MEDICAMENTOS RELEVANTES SUMINISTRADOS Y PRESCRITOS AL EGRESO</b><br><br><br>'+
                '<b>MANEJO DURANTE LA ESTANCIA HOSPITALARIA</b><br><br><br>'+
                '<b>PROBLEMAS CLÍNICOS PENDIENTE</b><br><br><br>'+
                '<b>PLAN DE MANEJO Y TRATAMIENTO</b><br><br><br>'+
                '<b>RECOMENDACIONES PARA LA VIGILANCIA AMBULATORIA</b><br><br><br>'+
                '<b>ESTADO AL MOMENTO DEL ALTA</b><br><br><br>'+
                '<b>PRONÓSTICO PARA LA VIDA</b><br><br><br>',

            12:  '<b>DATOS OBJETIVOS:</b><br><br><br>'+
                '<b>DATOS SUBJETIVOS:</b><br><br><br>'+
                '<b>DIAGNÓSTICOS Y RESULTADOS:</b><br><br><br>'+
                '<b>RESPUESTAS HUMANAS:</b><br><br><br>'+
                '<b>PATRONES:</b><br><br><br>'+
                '<b>INTERVENCIONES:</b><br><br><br>'+
                '<b>PROBLEMAS INDEPENDIENTES:</b><br><br><br>'+
                '<b>INTERVENCIONES DE COLABORACIÓN:</b><br><br><br>'+
                '<b>RESPUESTA Y EVOLUCIÓN:</b><br><br><br>',
        },
        tiposNotas:[
            {value:1, text:'Ingreso'},
            {value:3, text:'Evolución'},
            {value:8, text:'Post operatoria'},
            {value:11, text:'Egreso'},
        ],
        tiposNotasCreate:[
            {value:1, text:'Ingreso'},
            {value:3, text:'Evolución'},
            {value:8, text:'Post operatoria'},
            {value:11, text:'Egreso'},
        ],
        tiposNotasQx:[
        ],

        cirQxItemsFijo:[
            {label:'Inicia cirugía', model:'iniciaCirugia', ro:true},
            {label:'Termina cirugía', model:'terminaCirugia', ro:true},
            {label:'Cirugía programada', model:'procedimientoIndicado', ro:true},
            {label:'Cirugía realizada', model:'procedimientoRealizado', ro:true},
            {label:'Diagnóstico PRE operatorio', model:'padecimiento', ro:true},
            {label:'Diagnóstico POST operatorio', model:'diagPost', ro:false},
        ],
        cirQxItems:[
            {label:'Descripción de la técnica quirúrgica', model:'descripcionTecnica'},
            {label:'Hallazgos transoperatorios', model:'hallazgos'},
            {label:'Complicaciones', model:'complicaciones'},
            {label:'Estado postquirúrgico inmediato', model:'estadoPostQx'},
            {label:'Plan de manejo postquirúrgico inmediato', model:'planManejo'},
            {label:'Estudios transoperatorios', model:'estudiosTransop'},
            {label:'Reporte de gasas y compresas', model:'reporteGasas'},
            {label:'Isquemia casos ortopédicos', model:'isquemia'},
            {label:'Sangrado y/o transfusiones', model:'sangrado'},
            {label:'Piezas y biopsias quirúrgicas', model:'piezasBiopsia'},
            {label:'Pronósticos', model:'pronostico'},
            {label:'Incidentes y comentarios', model:'incidentes'},
        ],

        cirQxPersonal:[
            {label:'Cirujano', model:'cirujanoNombre'},
            {label:'Anestesiólogo', model:'anestesiologoNombre'},
            {label:'Ayudante', model:'ayudanteNombre'},
            {label:'Instrumentista', model:'instrumentaNombre'},
            {label:'Circulante', model:'circulaNombre'},
        ],

    },

    mutations:{
        //        CAMBIA_FECHA(state, data){
        //            state.fecha = data
        //        },
    },
    actions:{
        //
    },
    getters:{
        //
    },
}   